import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1109a3ce&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1109a3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1109a3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1109a3ce')) {
      api.createRecord('1109a3ce', component.options)
    } else {
      api.reload('1109a3ce', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1109a3ce&scoped=true&", function () {
      api.rerender('1109a3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LMIX710iBt7z/JS/comp/GuestBox.vue"
export default component.exports